import React, { useContext } from 'react';

import { Image } from '../atom/Image';
import { Button } from '../atom/Button';
import { Flex } from '../atom/Layout';
import { Text } from '../atom/Text';
import { InputForm } from '../organism/InputForm';
import { AllowMarketingCheck } from '../organism/AllowMarketing';

import PageTemplate from './PageTemplate';

import ModalContext from '../../../modules/contexts/Modalcontext';
import Term from '../../info/Term';
import Privacy from '../../info/Privacy';
import { HorizonGreyLine } from '../atom/HorizonGreyLine';

import { SIGNUP_MARKETINGAGREE } from '../../../lib/image/event/EventMarketingAgreeImages';

const SignupTemplate = ({
  onChangeValue,
  state,
  onSignup,
  isValidateTrue,
  isLoading,
  allowMarketing,
  allowMarketingCheck,
  isSns,
  readOnlyState = [],
}) => (
  <PageTemplate title={`${isSns ? 'SNS ' : ''}${PAGE_TITLE}`}>
    <InputForm
      formData={isSns ? SIGNUP_SNS_DATA : SIGNUP_DATA}
      onChangeValue={onChangeValue}
      state={state}
      onSubmit={onSignup}
      isValidateTrue={isValidateTrue}
      size={3}
      readOnlyState={readOnlyState}
    >
      <HorizonGreyLine style={{ marginTop: '1.625rem' }} />
      <SignupTerms />
      <AllowMarketingCheck
        allowMarketing={allowMarketing}
        onClick={allowMarketingCheck}
      />
      <Image
        src={SIGNUP_MARKETINGAGREE.src}
        alt={SIGNUP_MARKETINGAGREE.alt}
        margin="1rem 0 0"
      />
      <Flex column padding="2.5rem 0 1.25rem">
        <Button
          onClick={onSignup}
          isLoading={false}
          style={{ height: '2.5rem' }}
          color={isValidateTrue ? 'orangePink' : 'pinkishGrey'}
        >
          {SUBMIT_BUTTON}
        </Button>
      </Flex>
    </InputForm>
  </PageTemplate>
);

export default SignupTemplate;

const PAGE_TITLE = '회원가입';
const SUBMIT_BUTTON = '가입하기';
const SIGNUP_DATA = [
  {
    label: '이름',
    mainIconName: 'person',
    subIconName: null,
    placeholder: '예) 베이비페이스',
    type: 'text',
    name: 'name',
  },
  {
    label: '이메일',
    mainIconName: 'email',
    subIconName: null,
    placeholder: '예) babyface@babyface.com',
    type: 'email',
    name: 'email',
  },
  {
    label: '휴대폰',
    mainIconName: 'smartphone',
    subIconName: null,
    placeholder: '예) 01012341234',
    type: 'tel',
    name: 'mobile',
  },
  {
    label: '비밀번호',
    mainIconName: 'lock',
    subIconName: 'visibility',
    placeholder: '예) babyFace123@',
    type: 'password',
    name: 'password',
  },
  {
    label: null,
    mainIconName: 'lock',
    subIconName: 'visibility',
    placeholder: '비밀번호를 확인해주세요',
    type: 'password',
    name: 'passwordConfirm',
  },
];

const SIGNUP_SNS_DATA_FIELD = ['name', 'mobile', 'email'];
const SIGNUP_SNS_DATA = SIGNUP_DATA.filter((data) =>
  SIGNUP_SNS_DATA_FIELD.includes(data.name),
);

const SignupTerms = () => {
  const {
    actions: { onModal },
  } = useContext(ModalContext);

  return (
    <Flex padding="2.5rem 0" column alignItems="flex-start">
      <Text>[필수] 이용약관 동의</Text>
      <Flex padding="0.65rem 0 0">
        <div>
          {TERM_CONTENTS.map((content) => (
            <React.Fragment key={content.title}>
              <Text
                size="12"
                color="caption"
                onClick={() => onModal(content)}
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
              >
                {content.title}
              </Text>
              <Text size="12" color="caption">
                {content.text}
              </Text>
            </React.Fragment>
          ))}
        </div>
      </Flex>
    </Flex>
  );
};

const TERM_CONTENTS = [
  {
    title: '베이비페이스 이용약관',
    text: ', ',
    content: <Term />,
  },
  {
    title: '개인 정보 수집 및 이용약관',
    text: ' 및 ',
    content: <Privacy />,
  },
  {
    title: '개인정보제공',
    text: ' 내용을 확인하였으며, 동의합니다.',
    content: (
      <Text size={12}>
        귀하는 개인 정보의 선택적인 수집∙이용 제공에 대한 동의를 거부할 수
        있으나, 동의하지 않을 경우 편의 제공 (후기 이벤트 참여에 따른 무료
        서비스 제공, 기프트 선물 제공, 할인쿠폰) 에 따른 혜택에 제한이 있을 수
        있습니다.
        <br />
        <br /> 알레시오 (주) 는 “개인정보보호법”에 따라 아래와 같이 서비스의
        홍보 및 마케팅을 위한 개인정보를 수집∙이용 합니다.
        <br />
        <br />
        알레시오 (주)는 소중한 개인정보를 후기 공유 등의 자체 마케팅 외의
        목적(제 3자 제공 등)으로 사용하지 않음을 약속합니다.
      </Text>
    ),
  },
];
